<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">Reports</div>
            <div class="header-subtitle">{{ moduleData.subtitle }}</div>
          </template>
        </es-header>
      </div>
      <div class="content">
        <table class="table is-hoverable" width="100%">
          <thead>
            <tr>
              <th>Report Name</th>
              <th>Description</th>
              <th></th>
            </tr>
          </thead>
          <tbody
            v-for="(report,idx) in moduleData.reports"
            :key="idx"
          >
            <tr v-if="report.permission && hasModule(report.permission)">
              <td>
                <div class="is-flex flex-align--center">
                  <div
                      style="width: 40px;float: left;"
                      v-bind:class="{ 'fa-stack': report.stackIcon }">
                    <font-awesome-icon :icon="['fas', report.icon]"
                    size="2x" class="text-muted"/>
                    <font-awesome-icon
                        v-if="report.stackIcon"
                        :icon="['fas', report.stackIcon]"
                        v-bind:style="report.stackIconStyle"
                        size="2x"
                        class="text-muted fa-stack-1x" />
                  </div>
                  <div>
                    {{report.name}}
                  </div>
                </div>
              </td>
              <td>
                <div>{{report.description}}</div>
              </td>
              <td>
                <div>
                  <a
                    @click.prevent="onReportClick(report)"
                    :href="report.link"
                    :class="{ disabled: report.disabled }">
                    {{report.linkName}}
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faLandmarkAlt,
  faLandmark,
  faLandmarkFlag,
  faSchool,
  faMapMarkerAlt,
  faNotEqual,
  faSitemap,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAngleRight as faAngleRightSolid,
  faTimes as faTimesSolid,
  faCheckCircle as faCheckCircleSolid,
  faEdit as faEditSolid,
  faEllipsisH as faEllipsisHSolid,
  faFilter as faFilterSolid,
  faLandmarkAlt as faLandmarkAltSolid,
  faLandmark as faLandmarkSolid,
  faLandmarkFlag as faLandmarkFlagSolid,
  faSchool as faSchoolSolid,
  faBuilding as faBuildingSolid,
  faMapMarkerAlt as faMapMarkerAltSolid,
  faNotEqual as faNotEqualSolid,
  faSitemap as faSitemapSolid,
  faIdBadge as faIdBadgeSolid,
  faWindowClose as faWindowCloseSolid,
  faExclamationCircle as faExclamationCircleSolid,
  faHistory as faHistorySolid,
  faSlash as faSlashSolid,
} from '@fortawesome/pro-solid-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faLandmarkAlt,
  faLandmark,
  faLandmarkFlag,
  faSchool,
  faMapMarkerAlt,
  faNotEqual,
  faSitemap,
  faAngleRightSolid,
  faTimesSolid,
  faCheckCircleSolid,
  faEditSolid,
  faEllipsisHSolid,
  faFilterSolid,
  faLandmarkAltSolid,
  faLandmarkSolid,
  faLandmarkFlagSolid,
  faSchoolSolid,
  faBuildingSolid,
  faMapMarkerAltSolid,
  faNotEqualSolid,
  faSitemapSolid,
  faIdBadgeSolid,
  faWindowCloseSolid,
  faExclamationCircleSolid,
  faHistorySolid,
  faSlashSolid,
);

export default {
  mixins: [PermissionManager],
  props: {
    pidAvailableReportTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      reportType: '',
      allModuleData: {
        directMatch: {
          subtitle: 'Customize or generate report.',
          reports: [
            {
              icon: 'landmark-alt',
              name: 'FNS-834',
              description: 'This is Direct Certification Data Element Report to FNS submitted by the State. ',
              link: '/directMatch/reportdescriptions/customizefns834report',
              linkName: 'Customize Report ',
              permission: 'DRMCH:REP:FNS834',
            },
            {
              icon: 'landmark',
              name: 'May Report to USDA',
              description: 'This report is CEP eligibility report using April 1 student data.',
              linkName: 'Generate Report ',
              permission: 'DRMCH:REP:MAYUSDA',
              async fn() {
                try {
                  const res = await axios.post('/reports/', ({
                    reportType: 'MAY',
                  }));
                  this.$emit('reportCreated', res.data);
                } catch (err) {
                  console.error(err);
                  this.messages.push(this.formErrorMsg);
                  this.showNotification('danger', this.messages);
                }
              },
            },
            {
              icon: 'landmark-flag',
              name: 'Population Data',
              description: 'This report is retrieves the Population Data entered into CEP Manager as of the open date and close date for the selected year.',
              link: '/directMatch/reportdescriptions/customizepopulationreport',
              linkName: 'Customize Report ',
              permission: 'DRMCH:REP:POP',
            },
            {
              icon: 'school',
              name: 'September Report to USDA',
              description: 'This report is CEP participation report based on June 30 submission data.',
              linkName: 'Generate Report ',
              permission: 'DRMCH:REP:SEPTUSDA',
              async fn() {
                try {
                  const res = await axios.post('/reports/', ({
                    reportType: 'SEPTEMBER',
                  }));
                  this.$emit('reportCreated', res.data);
                } catch (err) {
                  console.error(err);
                  this.messages.push(this.formErrorMsg);
                  this.showNotification('danger', this.messages);
                }
              },
            },
            {
              icon: 'building',
              name: 'Locations Serving only NSLP with High ISP',
              description: `This report lists locations serving only National School Lunch Program with ISP >= ${this.$store.state.propertiesModule.properties['CEP-ISP_PERCENT'] * 100}%.`,
              linkName: 'Generate Report ',
              permission: 'DRMCH:REP:LOCNSLP',
              async fn() {
                try {
                  const res = await axios.post('/reports/', ({
                    reportType: 'LOCNSLP',
                  }));
                  this.$emit('reportCreated', res.data);
                } catch (err) {
                  console.error(err);
                  this.messages.push(this.formErrorMsg);
                  this.showNotification('danger', this.messages);
                }
              },
            },
          ],
        },
        locationID:
        {
          subtitle: 'Select and customize report.',
          reports: [
            {
              icon: 'map-marker-alt',
              name: 'All Locations Report',
              description: 'This report includes all locations with unique State Location ID with associated information.',
              link: '/locationID/reportdescriptions/customizelocationreport',
              linkName: 'Customize Report',
              permission: 'LOCID:REP:LOCATIONS',
            },
            {
              icon: 'sitemap',
              name: 'Location by Group with Hierarchy',
              description: 'This report includes locations with parent and child relationship within a location group',
              link: '/locationID/reportdescriptions/customizelocationbygroupreport',
              linkName: 'Customize Report',
              permission: 'LOCID:REP:LOCBYGROUP',
            },
            {
              icon: 'not-equal',
              name: 'Distinct Local Code Report',
              description: 'This report includes locations with different local codes across different organizations..',
              link: '/locationID/reportdescriptions/customizelocalcodereport',
              linkName: 'Customize Report',
              permission: 'LOCID:REP:LOCALCODE',
            },
          ],
        },
        personId:
        {
          subtitle: 'Customize report',
          reports: [
            {
              icon: 'id-badge',
              name: 'Alias ID',
              description: 'This Report provides alias ID information on person records in the application.',
              link: '/personid/reportdescriptions/aliasidreport/customize',
              linkName: 'Customize Report',
              permission: 'PRSID:REP:ALIASID',
              code: 'PID_ALIAS',
            },
            {
              icon: 'window-close',
              name: 'Canceled Record',
              description: 'This Report provides administrators with information on canceled records in the applicationto help identify potential issues or training needs.',
              link: '/personId/reportdescriptions/canceledrecordreport/customize',
              linkName: 'Customize Report',
              permission: 'PRSID:REP:CANCELED',
              code: 'PID_CANCELED',
            },
            {
              icon: 'exclamation-circle',
              name: 'Near Match By Location',
              description: 'This Report provides administrators with information on any pending near matches in the application.',
              link: '/personId/reportdescriptions/nearmatchbylocationreport/customize',
              linkName: 'Customize Report',
              permission: 'PRSID:REP:NEARMATCHBYLOC',
              code: 'PID_NML',
            },
            {
              icon: 'history',
              stackIcon: 'slash',
              stackIconStyle: {
                marginLeft: '-2px',
              },
              name: 'No History',
              description: 'This Report provides administrators with information on any districts or schools that have not submitted date within a specified date range.',
              link: '/personid/reportdescriptions/nohistoryreport/customize',
              linkName: 'Customize Report',
              permission: 'PRSID:REP:NOHIST',
              code: 'PID_NO_HIST',
            },
            {
              icon: 'history',
              name: 'Submission History',
              description: 'This Report provides administrators with information on any districts or schools that have submitted date within a specified date range.',
              link: '/personid/reportdescriptions/submissionhistoryreport/customize',
              linkName: 'Customize Report',
              permission: 'PRSID:REP:SUBMHIST',
              code: 'PID_SUB_HIST',
            },
          ],
        },
      },
    };
  },
  components: {
    EsHeader,
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    moduleData() {
      if (this.activeModule.name === 'personId') {
        this.allModuleData.personId.reports.forEach((r) => {
          const report = r;
          report.disabled = !this.pidAvailableReportTypes.find(rt => rt.code === r.code);
        });
      }
      return this.allModuleData[this.activeModule.name];
    },
  },
  methods: {
    onReportClick(report) {
      if (report.link) {
        this.$router.push(report.link);
      } else if (typeof (report.fn) === 'function') {
        report.fn.call(this);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .input
    width: 40%
  .tag
    margin-left: 8px
  .text-muted
    color: #6c757d !important
  // TODO: remove this and disabled prop from template when we implement all
  // person id reports
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
</style>
